import { api } from "./client";
import { apiRoutes } from "util/apiRoutes";
import type { ImpactDimensionFilter } from "util/constants";

export interface PostListParams {
  kind?: string | null;
  status?: string | null;
  issueId?: number | null;
  userId?: number | "me" | null;
  collectionType?: string | null;
  dimensionFilter?: ImpactDimensionFilter;
  limit?: number;
  offset?: number;
  sortField?: "created_at" | "updated_at" | "vote_count";
  sortOrder?: "ASC" | "DESC";
}

export interface TeabatePostListItem {
  id: number;
  kind: "teabate";
  issue_id: number | null;
  title: string | null;
  body: string | null;
  username?: string;
  display_name?: string;
  properties_public?: Record<string, unknown> | null;
  properties: Record<string, unknown>;
  created_at: string | null;
  updated_at: string | null;
}

export const postApi = {
  async listPosts<TPost = Record<string, unknown>>(params: PostListParams): Promise<TPost[]> {
    const response = await api.get<TPost[]>(apiRoutes.posts.root, { params });
    return response.data;
  },

  async listDimensionedTeabates({
    issueId = null,
    userId = null,
    limit = 20,
    offset = 0,
    sortField = "created_at",
    sortOrder = "DESC",
  }: {
    issueId?: number | null;
    userId?: number | "me" | null;
    limit?: number;
    offset?: number;
    sortField?: "created_at" | "updated_at" | "vote_count";
    sortOrder?: "ASC" | "DESC";
  }): Promise<TeabatePostListItem[]> {
    return postApi.listPosts<TeabatePostListItem>({
      kind: "teabate",
      issueId,
      userId,
      dimensionFilter: "teabate-with-dimensions",
      limit,
      offset,
      sortField,
      sortOrder,
    });
  },
};
